export default __webpack_public_path__ + "static/media/duster-techroad-gallery-1.5ba8c1ab.jpg";